export abstract class Entity<T extends number | string> {
  id: T;

  protected constructor(params: EntityParams<T>) {
    this.id = params.id;
  }
}

export type EntityParams<T extends number | string> = {
  id: T;
};
